import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { t } from 'i18next';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { TextAndViewLocationsContainer } from '../../SmartChoiceBreakDown.styles';
import {
  StyledButton,
  TextOnBottomOfProgressBar,
} from '../BenfitsBreakDown.styles';

interface TotalCostOfCareTextWithLinkProps {
  text: string;
  handleTabChange?: (tab: number, isAnalyticsEnabled?: boolean) => void;
  isCost?: boolean;
  isViewLink?: boolean;
  textColor?: string;
}
export const TotalCostOfCareTextWithLink = ({
  text,
  handleTabChange,
  isCost,
  isViewLink,
  textColor,
}: TotalCostOfCareTextWithLinkProps) => (
  <>
    <TextAndViewLocationsContainer alignItems="flex-start" direction="column">
      <TextOnBottomOfProgressBar color={textColor}>
        {text}
      </TextOnBottomOfProgressBar>
      {isViewLink && (
        <StyledButton
          data-testid="view-locations-benifits"
          onClick={() => {
            adobeLinkTrackEvent({
              name: `View ${isCost ? 'Costs' : 'Locations'}`,
              location: 'Smart choice benefits breakdown',
            });
            handleTabChange?.(isCost ? 3 : 1, false);
          }}
          style={{ marginTop: '8px' }}
          variant="text"
        >
          {t(`SMART_CHOICE.VIEW_${isCost ? 'COSTS' : 'LOCATIONS'}`)}
          <IconSymbol icon="chevron_right" size={16} />
        </StyledButton>
      )}
    </TextAndViewLocationsContainer>
  </>
);
